import { format, subMonths } from 'date-fns'
import { FetchJournalEntriesQuery } from '../../generated'
import { AccountOption } from './common'

export enum EntryFilterType {
  ALL = 'all',
  SYSTEM = 'system',
  MANUAL = 'manual'
}

export interface JournalEntriesFilters {
  account?: AccountOption
  startDate?: string
  endDate?: string
  type?: EntryFilterType
  searchTerm?: string
}

export interface JournalEntriesState {
  journalEntries: FetchJournalEntriesQuery['fetchJournalEntries']['journalEntries']
  filters: JournalEntriesFilters
  loading: boolean
}

export const journalEntriesInitialState: JournalEntriesState = {
  journalEntries: [],
  filters: {
    startDate: format(subMonths(new Date(), 1), 'MM/dd/yyyy'),
    endDate: format(new Date(), 'MM/dd/yyyy'),
    type: EntryFilterType.MANUAL
  },
  loading: false
}

export enum JournalEntriesActionType {
  SET_JOURNAL_ENTRIES = 'setJournalEntries',
  SET_FILTERS = 'setFilters',
  SET_LOADING = 'setLoading',
  RESET_FILTERS = 'resetFilters'
}

export type JournalEntriesAction =
  | {
    type: JournalEntriesActionType.SET_JOURNAL_ENTRIES
    journalEntries: FetchJournalEntriesQuery['fetchJournalEntries']['journalEntries']
  }
  | { type: JournalEntriesActionType.SET_FILTERS; filters: JournalEntriesFilters }
  | { type: JournalEntriesActionType.SET_LOADING; loading: boolean }
  | { type: JournalEntriesActionType.RESET_FILTERS }

export interface JournalEntriesListingProps {
  journalEntries: FetchJournalEntriesQuery['fetchJournalEntries']['journalEntries']
  loading: boolean
  refetch: () => void
  onDuplicate: (id: string) => void
}
